import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InfoService {
  host_Info = `${environment.API_URI}/api/info`;

  constructor(private http: HttpClient) { }

    private getAuthHeaders(): HttpHeaders {
    const purecloud_auth_data = localStorage.getItem('purecloud_auth_data');
    const token = purecloud_auth_data ? JSON.parse(purecloud_auth_data).accessToken : null;

    if (!token) throw new Error("Missing access token");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  // Récupérer la liste des infos
  getAllInfos(code_do: number) {
    const url = `${this.host_Info}/select/all/${code_do}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }

  // Récupérer les libelles des infos
  getAllLibelleInfos(code_do: number) {
    const url = `${this.host_Info}/select/libelle/${code_do}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }

  addInfo(info: any){
    const url = `${this.host_Info}/add`;
    return this.http.post(url, info, { headers: this.getAuthHeaders() });
  }

   updateInfo(code_interne: number,info: any){
    const url = `${this.host_Info}/update/${code_interne}`;
    return this.http.put(url, info, { headers: this.getAuthHeaders() });
  }
  deleteInfo(code_Internes: number[]) {
    const url = `${this.host_Info}/delete`;
    const options = {
      headers: this.getAuthHeaders(),
      body: { code_interne: code_Internes }
    };
  return this.http.delete(url, options);  }


  addEmptyRowLibelleInfos(code_DO: number) {
    const url = `${this.host_Info}/libelle/add`;
    return this.http.post(url, {code_DO}, { headers: this.getAuthHeaders() });
  }

  updateLibelleInfos(code_DO: number, libelleInfo: any) {
    const url = `${this.host_Info}/libelle/update/${code_DO}`;
    return this.http.put(url, libelleInfo, { headers: this.getAuthHeaders() });
  }
exportTemplateInfo() {
    const url = `${this.host_Info}/export/template`;
    return this.http.get(url, {
      responseType: 'blob',
      headers: this.getAuthHeaders()
    });
  }

  importCsvInfo(code_do : number,add_on:string, file: File): Observable<HttpEvent<any>> {
    const url = `${this.host_Info}/bulk-import/`;
    const formData = new FormData();
    formData.append('csvInfoFile', file);

    const req = new HttpRequest('POST', url + code_do+'/' + add_on, formData, {
      reportProgress: true,
      headers: this.getAuthHeaders(),
      responseType: 'json'
    });

    return this.http.request(req);
  }

}
